<template>
  <div class="intent-item pa-2 mb-3" :style="{
    border: `1px solid ${$vuetify.theme.primary}`,
    'border-left': '5px solid red'
  }">
    <div style="display: flex; justify-content: space-between;">
      <div style="display: flex; align-items: center; gap: 3px;">
        <toggle-button
          :value="false"
          :labels="{ unchecked: 'OFF' }"
          style="display: inline-block"
          disabled
        />
        ChatGPT Plus
      </div>
      <div>
        <v-premium-lock2
          :inline="true"
          class="ml-2"
          :value="true"
          :type="type"
          :text="text"
        ></v-premium-lock2>
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton
  },
  props: {
    type: {
      default: 'premium'
    },
    text: {
      default: ''
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/view/intent/intent-item-lock.vue